<template>
  <ul class="divide-y divide-gray-200">
    <TemporaryMediaUploadListItem
      v-for="temporaryMediaUpload in temporaryMediaUploads"
      :key="temporaryMediaUpload.id"
      :temporary-upload="temporaryMediaUpload"
      :on-remove="onRemove"
    />
  </ul>
</template>

<script>
import TemporaryMediaUploadListItem from './TemporaryMediaUploadListItem.vue';

export default {
  components: {
    TemporaryMediaUploadListItem,
  },
  props: {
    temporaryMediaUploads: {
      type: Array,
      default: () => [],
    },
    onRemove: {
      type: Function,
      required: true,
    },
  },
};
</script>
